import React from 'react';

const DEMO_TICKETS = [
    { title: 'Replace air filter — AHU 2', due: 'Today', priority: 'high' },
    { title: 'Calibrate flow meter FM-14', due: 'in 3 days', priority: 'medium' },
    { title: 'Inspect transformer T1 oil level', due: 'in 6 days', priority: 'low' },
];

const PRIORITY_COLOR = { high: '#d03b3b', medium: '#d69e00', low: '#0ca30c' };

const MaintenanceTicketsWidget = ({ config }) => {
    const { dataSource = {} } = config;
    const tickets = dataSource.tickets || DEMO_TICKETS;

    return (
        <div className="maint-tickets-widget">
            {tickets.map((t, i) => (
                <div className="maint-tickets-widget__row" key={i}>
                    <span
                        className="maint-tickets-widget__priority"
                        style={{ backgroundColor: PRIORITY_COLOR[t.priority] || '#9ca3af' }}
                        title={t.priority}
                    />
                    <div className="maint-tickets-widget__body">
                        <div className="maint-tickets-widget__title">{t.title}</div>
                        <div className="maint-tickets-widget__due">Due {t.due}</div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default MaintenanceTicketsWidget;
